<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-26 14:52:50
 * @LastEditors: pj
 * @LastEditTime: 2022-11-16 10:17:38
-->
<template>
    <div>
        <!-- 搜索框 -->
        <a-card size="small" title="渠道管理">
            <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>

            <searchE @handleSearch="handleSubmit" @handlePlatforms="handlePlatformsData"></searchE>

            <tableE ref="channelTableID" :platForms="platforms" @onRefresh="onRefresh"></tableE>

        </a-card>

    </div>
</template>
<script>
import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            searchP: {},
            platforms: [],
        }
    },
    methods: {
        handleSubmit(searchP) {
            this.$refs.channelTableID.handleSearch(searchP)
        },
        handleNew() {
            this.$router.push({
                path: 'add_channel',
                query: { id: '' },
            })
        },
        handlePlatformsData(result) {
            this.platforms = result
        },
    },
    components: {
        searchE,
        tableE,
    },
    mounted() {},
}
</script>
<style scoped>
</style>
